import React from 'react'
// c:\xampp\htdocs\miners-market-main\components\BasketQuoteItemsModal.js

export default function BasketQuoteItemsModal({ isOpen, onClose, items, onViewProduct }) {
    const [loading, setLoading] = React.useState(false);

    const formatPrice = (price) => {
        const num = parseFloat(price);
        if (isNaN(num)) return 'R 0.00';
        return `R ${num.toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const calculateLineTotal = (item) => {
        const price = parseFloat(item.price) || 0;
        const quantity = item.quantity || 1;
        return price * quantity;
    };

    const calculateTotal = () => {
        return items.reduce((total, item) => total + calculateLineTotal(item), 0);
    };

    const handleItemClick = (item) => {
        onViewProduct(item.id, item.listingType);
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4" onClick={onClose}>
            <div className="bg-white w-full max-w-2xl max-h-[90vh] rounded-2xl flex flex-col overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b bg-gray-50">
                    <h2 className="text-lg font-semibold text-gray-800">Basket Quote Items</h2>
                    <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-2xl">
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                {/* Items List */}
                <div className="flex-1 overflow-y-auto p-4">
                    {loading ? (
                        <div className="flex items-center justify-center py-8">
                            <i className="fas fa-spinner fa-spin text-2xl text-blue-500"></i>
                        </div>
                    ) : items.length === 0 ? (
                        <div className="text-center py-8 text-gray-500">
                            <i className="fas fa-shopping-basket text-4xl mb-2"></i>
                            <p>No items found in this basket quote</p>
                        </div>
                    ) : (
                        <div className="space-y-3">
                            {items.map((item, index) => (
                                <div 
                                    key={`${item.id}-${item.listingType}-${index}`}
                                    className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors"
                                    onClick={() => handleItemClick(item)}
                                >
                                    {/* Image */}
                                    <img 
                                        src={item.image_url_1 || 'https://via.placeholder.com/150'} 
                                        alt={item.name} 
                                        className="w-16 h-16 object-cover rounded-lg"
                                    />
                                    
                                    {/* Details */}
                                    <div className="flex-1 min-w-0">
                                        <h3 className="font-semibold text-gray-900 truncate">{item.name}</h3>
                                        <p className="text-sm text-gray-500">{item.listing_number}</p>
                                        <div className="flex items-center gap-2 mt-1">
                                            <span className="text-sm text-gray-600">Qty: {item.quantity}</span>
                                            <span className="text-sm text-gray-600">×</span>
                                            <span className="text-sm font-medium text-blue-600">{formatPrice(item.price)}</span>
                                        </div>
                                    </div>

                                    {/* Line Total */}
                                    <div className="text-right">
                                        <p className="font-semibold text-gray-900">{formatPrice(calculateLineTotal(item))}</p>
                                        <p className="text-xs text-gray-500">Click to view details</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Footer */}
                {items.length > 0 && (
                    <div className="border-t bg-gray-50 p-4">
                        <div className="flex justify-between items-center">
                            <span className="text-gray-600 font-medium">Total ({items.length} items)</span>
                            <span className="text-xl font-bold text-blue-600">{formatPrice(calculateTotal())}</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
